module.exports = __webpack_public_path__ + "static/media/cambridge_uni_logo.740e16b7.png";